module.exports = __webpack_public_path__ + "static/img/icon3@2x.f572a162.png";